module.exports = __webpack_public_path__ + "img/ArtificialIntelegent.306c9d16.jpg";